import React from 'react';

import Typography from '../../../../../../library/typography/typography';
import ProductArticleStatusBanner from '../../../../../../components/product-article-status-banner/product-article-status-banner';
import ProductAvailability from '../../../../../../components/product-availability/product-availability';
import { ExclamationCircleRegularIcon } from '../../../../../../shared/icons/icons';

import {
  getPrioritizedArticleStatusProduct,
  getShouldShowProductArticleStatusBanner
} from '../../../../../../shared/utils/product/product';

import { BundleData } from '../../../../../../shared/types/product';

import './product-list-package-card-header.scss';

interface ProductListPackageCardHeaderProps {
  prebuiltPackage: BundleData;
  quantity: number;
}

function ProductListPackageCardHeader(
  props: ProductListPackageCardHeaderProps
) {
  const { prebuiltPackage, quantity } = props;

  const articleStatusProduct = getPrioritizedArticleStatusProduct(
    prebuiltPackage?.product1,
    prebuiltPackage?.product2
  );
  const shouldShowProductArticleStatusBanner =
    getShouldShowProductArticleStatusBanner(articleStatusProduct);

  return (
    <header styleName="container">
      <div styleName="heading">
        <Typography styleName="name" variant="H6" weight="black">
          Wheel & Tire Package
        </Typography>
        <div styleName="package-includes">
          <ExclamationCircleRegularIcon styleName="includes-icon" />
          Package includes: 4 tires and 4 wheels
        </div>
      </div>
      <div styleName="availability">
        {!shouldShowProductArticleStatusBanner && (
          <ProductAvailability
            prebuiltPackage={prebuiltPackage}
            product={articleStatusProduct}
            quantity={quantity}
          />
        )}
        {shouldShowProductArticleStatusBanner && (
          <ProductArticleStatusBanner product={articleStatusProduct} />
        )}
      </div>
    </header>
  );
}

export default ProductListPackageCardHeader;
